import React from 'react';
import './Demographics.css';
import Header from "../../Header/Header"
import SolutionsImage from "../../images/solutions.png";
import phoneImage from "../../images/phone.png";
import laptopImage from "../../images/laptop.png";
import HeroSection from '../../Components/HeroSection/HeroSection';
import { Container, Row, Col } from 'bootstrap-4-react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import CircularBar from '../../Components/CircularBar/CircularBar';
import PictureText from "../../Components/PictureText/PictureText";
import Footer from '../../Footer/Footer';
import ReactGA from 'react-ga';

class Demographics extends React.Component{
     componentDidMount() {
         ReactGA.pageview('/demographics/');
     }
    render() {
        window.scrollTo(0, 0);
        let text1 = <p>
We always keep the product and service users’ requirements at the forefront of our minds. From initial concept through to design and delivery, we provide intuitive and easy to use services allowing for a seamless customer journey.          </p>;
        let text2 = <p>
            One of our key competitive advantages is that we provide a full digital marketing platform adapted to mobile markets (SMS, USSD, web mobile) complemented by profiling and segmenting clients’ target customers based on defined KPIs. Our analytics tools monitor the real time effect of marketing actions, whilst our machine learning models and Artificial Intelligence algorithms make business analysis a far more effective discipline.
        </p>
       return (
        <div className="solutions-page">
            <Header />
            <HeroSection pageTitle="Solutions" background={SolutionsImage} />
            <section className="page-content">
                <Container>
                    <ul className="breadcrumbs">
                        <li><Link to="/">Homepage</Link></li>
                        <li><Link to="/demographics/" className="current">Demographics</Link></li>
                    </ul>
                </Container>
            
                <section className="demographics-bar">
                    <h2 className="second-title"><i className="fa fa-circle"></i> <span> Demographics </span><i className="fa fa-circle"></i></h2>
                    <Container>
                        <Row>
                            <Col col="md-4 12">
                                <div className="bar-container">
                                    <CircularBar type={"services"} percentage={"75"} extra="" round={"500"}/>
                                    <h3>Services</h3>
                                    <span className="extrainfo">Across 3 Continents</span>
                                </div>
                            </Col>
                            <Col col="md-4 12">
                                <div className="bar-container">
                                <CircularBar type={"subscribers"} percentage={"90"} extra="M" round={"110"} />
                                <h3>Subscribers</h3>
                                <span className="extrainfo">Accessible Customers</span>
                                </div>
                            </Col>
                            <Col col="md-4 12">
                                <div className="bar-container">
                                <CircularBar type={"presence"} percentage={"50"} extra="" round={"25"} />
                                <h3>Presence</h3>
                                <span className="extrainfo">Countries across 3 Continents</span>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col col="10 12" offset="md-1" className="text-container">
                                <p className="text text-center">
                                   We run mobile services in more than 25 countries: <br/>
                                    12 African countries<br/>
                                    25 mobile operator partnerships<br/>
                                    More than 110 million covered subscribers<br/>
                                    More than 15 million active subscribers<br/>
                                    More than 25 million financial transactions per day
                                </p>
                                
                            </Col>
                        </Row>
                    </Container>
                </section>
                <PictureText picture={phoneImage} sectionTitle="UI/UX DESIGNS" text={text1} subtitle="" align="" />
                <PictureText picture={laptopImage} sectionTitle="DIGITAL MARKETING" text={text2} subtitle="BECAUSE NOTHING GETS YOU CLOSER TO YOUR CUSTOMERS THAN MOBILE" align="right" />
            </section>
            <Footer />
        </div>
       );
    }
}
export default Demographics;
